export const IMAGES_PATH = "assets/images/";